import { useQuery } from "@tanstack/react-query";
import { getLicenseChangesApi } from "../api/licenseChangesApi";

export const LICENSE_CHANGES_QUERY_KEY = ["licenseChanges"];

export const useLicenseChangesQuery = (month: string, resellerId?: string) => {
  return useQuery({
    queryKey: [...LICENSE_CHANGES_QUERY_KEY, resellerId ?? "admin", month],
    queryFn: () => getLicenseChangesApi(month, resellerId),
  });
};
